export const getGraphNode = (data, collectionName) =>
  data["allContentful" + collectionName].edges[0].node;



// WEBPACK FOOTER //
// ./src/selectors.js